import { FC } from 'react'

import { AUTH_TYPE } from '../../../infrastructure/enums/authentication.enum'
import {
  Button,
  Container,
  LoginFormContainer,
  CompanyLogo,
  HeaderText,
  ChoiceTitle,
  ButtonText,
  ButtonContainer,
  HeaderContainer,
} from './login.styles'
import companylogo from '../../../infrastructure/assets/logo_white_v2.png'
import { useCustomTranslation } from '../../../infrastructure/translation/useCustomTranslation'

const LoginPage: FC<{ handleSelectAuthType: (type: AUTH_TYPE) => void }> = ({
  handleSelectAuthType,
}) => {
  const { t } = useCustomTranslation('common')
  return (
    <Container>
      <LoginFormContainer>
        <HeaderContainer>
          <CompanyLogo src={companylogo} />
          <HeaderText>{t('welcome_to_urbasolar_client')}</HeaderText>
        </HeaderContainer>
        <ButtonContainer>
          <ChoiceTitle>{t('select_a_profil')}</ChoiceTitle>
          <Button onClick={() => handleSelectAuthType(AUTH_TYPE.EXTERNAL)}>
            <ButtonText>{t('client')}</ButtonText>
          </Button>
          <Button onClick={() => handleSelectAuthType(AUTH_TYPE.INTERNAL)}>
            <ButtonText>{t('urbasolar_employee')}</ButtonText>
          </Button>
        </ButtonContainer>
      </LoginFormContainer>
    </Container>
  )
}

export default LoginPage
